import { gsap } from 'gsap';

export function loadingEnter(el) {
  const container = el.querySelector('.ui-loading__container');
  const tl = gsap.timeline();

  gsap.set(container, { opacity: 0 });

  tl.addLabel('start')
    .to(container, {
      opacity: 1,
      ease: 'bloom',
      duration: 2,
      delay: 0.4,
    }, 'start');

  return tl;
}

export function loadingLeave(el) {
  const container = el.querySelector('.ui-loading__container');
  const tl = gsap.timeline();

  tl.addLabel('start')
    .to(container, {
      opacity: 0,
      ease: 'bloom',
      duration: 1,
    }, 'start');

  return tl;
}
